import {
   ADD_ISSUE_LINE_ITEM,
   UPDATE_ISSUE_LINE_ITEM,
   GET_ISSUE_LINE_ITEM,
   GET_ISSUES_LINE_ITEM,
   DELETE_ISSUE_LINE_ITEM,
} from '../types';

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_ISSUES_LINE_ITEM:
         return { ...state, list: payload };
      case GET_ISSUE_LINE_ITEM:
         return { ...state, single: payload || initialState.single };

      case UPDATE_ISSUE_LINE_ITEM:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_ISSUE_LINE_ITEM:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_ISSUE_LINE_ITEM:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      default:
         return state;
   }
};

export default reducer;
